import axios from 'axios';
import * as _ from 'underscore';

/**
 * Set to 'production', 'staging' or 'dev'.
 * 'dev' requires running the backend locally, staging hits a production-like
 * server that accepts requests from localhost.
 */
const ENV = 'production';

const PROD_URL = 'https://donorsearch-api.techforcampaigns.co';
const STAGING_URL =
  'http://pa-fundraising-search-dev.us-east-2.elasticbeanstalk.com';
const DEV_URL = 'http://localhost:5000';

const getBaseURL = () => {
  let url;
  switch (ENV) {
    case 'staging':
      url = STAGING_URL;
      break;
    case 'dev':
      url = DEV_URL;
      break;
    default:
      url = PROD_URL;
  }
  return url;
};

export const login = idToken => {
  return new Promise(resolve => {
    axios
      .post(
        `${getBaseURL()}/login`,
        { googleToken: idToken },
        { withCredentials: true }
      )
      .then(({ data }) => {
        resolve(data.userId);
      });
  });
};

export const getDonations = (query, limit, offset) => {
  let queryUrl = `${getBaseURL()}/donors/contributions?limit=${limit}&offset=${offset}&`;
  _.mapObject(query, (value, key) => {
    if (value !== undefined && value) {
      queryUrl += `${encodeURIComponent(key)}=${encodeURIComponent(value)}&`;
    }
  });
  queryUrl = queryUrl.replace(/&+$/, ''); // trim trailing ampersand
  return new Promise(resolve => {
    axios.get(queryUrl, { withCredentials: true }).then(data => {
      resolve(data.data);
    });
  });
};

export const exportCSV = query => {
  let queryUrl = `${getBaseURL()}/donors/contributions?export=csv&`;
  _.mapObject(query, (value, key) => {
    if (value !== undefined && value) {
      queryUrl += `${encodeURIComponent(key)}=${encodeURIComponent(value)}&`;
    }
  });
  queryUrl = queryUrl.replace(/&+$/, ''); // trim trailing ampersand
  return new Promise(resolve => {
    axios
      .get(queryUrl, { withCredentials: true, responseType: 'blob' })
      .then(data => {
        const url = window.URL.createObjectURL(new Blob([data.data]));
        const link = document.createElement('a');
        link.href = url;
        const date = new Date();
        link.setAttribute(
          'download',
          `${date.toLocaleDateString()} ${date.toLocaleTimeString()}.csv`
        );
        document.body.appendChild(link);
        link.click();
        resolve(data.data);
      });
  });
};



// WEBPACK FOOTER //
// ./src/util/api.js